import { FC, memo, Suspense, lazy } from 'react';
import { useQuoteFormContext } from "./context";

// Lazy
const StepOne = lazy(() => import("./components/step-one-form"));
const StepTwo = lazy(() => import("./components/step-two-form"));
const StepThree = lazy(() => import("./components/step-three-form"));

interface Props {
    id: number;
    userId: number;
}

const QuoteCreatePage: FC<Props> = ({
    id ,
    userId,
}) => {
    const { formStep } = useQuoteFormContext();

    return (
        <Suspense fallback="Loading...">
            {formStep === 1 && (
                <StepOne
                    quoteId={id}
                    userId={userId}
                />
            )}
            {formStep === 2 && (
                <StepTwo
                    quoteId={id}
                />
            )}
            {formStep === 3 && (
                <StepThree
                    quoteId={id}
                />
            )}
        </Suspense>
    );
};

export default memo(QuoteCreatePage);
